document.addEventListener('DOMContentLoaded', function(){
	const sliders = document.querySelectorAll(".wrapper__slider-carousel");

	sliders.forEach((sliderWrapper) => {
		
		const slider = sliderWrapper.querySelector('.swiper');
		const prevButton = slider.querySelector(".swiper-button-prev");
		const nextButton = slider.querySelector(".swiper-button-next");
		const autoplaySpeed = parseInt(sliderWrapper.getAttribute("data-autoplay-speed")) * 1000;
		let {
			viewDesktopLarge,
			viewDesktop,
			viewTablet,
			viewMobile,
			autoplay,
			arrows,
			customClass,
		} = sliderWrapper.dataset;
	
		// Set 'auto' perView when select the value 1
		viewDesktopLarge == 1 ? (viewDesktopLarge = "auto") : viewDesktopLarge;
		viewDesktop == 1 ? (viewDesktop = "auto") : viewDesktop;
		viewTablet == 1 ? (viewTablet = "auto") : viewTablet;
		viewMobile == 1 ? (viewMobile = "auto") : viewMobile;

		let navigation;

		if(arrows){
			navigation = {
				nextEl: nextButton,
        		prevEl: prevButton,
			}
		}
	
	
		const breakpointsCustom = {
			580: {
				slidesPerView: viewTablet,
				spaceBetween: 20
			},
			1200: {
				slidesPerView: viewDesktop,
				spaceBetween: 28,
			},
			1380: {
				slidesPerView: viewDesktopLarge,
				spaceBetween: 28,
			},
		};
	
		const initializeSlider = function () {
			swiper = new Swiper(slider, {
				loop: true,
				speed: 2000,
				slidesPerView: viewMobile,
				spaceBetween: 30,
				allowMouseEvents: false,
				autoplay: {
					delay: 0
				},
				breakpoints: breakpointsCustom,
				navigation: navigation
			});
		};
	
		initializeSlider();
	});
});

